import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=107d2f5d&scoped=true&"
import script from "./CreateCompany.vue?vue&type=script&lang=js&"
export * from "./CreateCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=107d2f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d2f5d",
  null
  
)

export default component.exports